<template>
  <div id="app">

    <br/>
    <vx-card title="Pesquisar" :collapse-action="true">
                
        <vs-row class="custom1" vs-w="12">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                <h5>Nome*</h5>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="7" vs-sm="5" vs-xs="12">
                <vs-input class="w-full"  v-model="rowSearch.nome" id="input-nome"
                   autocomplete="off" icon-pack="feather" icon="icon-user" icon-no-border
                /> 
            </vs-col>            
        </vs-row>  
        
        <br/>
        <vs-row class="custom1" vs-w="12">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                <h5>Data de Nascimento</h5>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="5" vs-xs="12">
                <datepicker 
                    :calendar-class="'calendar_date'"
                    :format="datepickerFormat"
                    :initial-view="'year'"
                    v-model="rowSearch.data_nascimento"
                    name="event_date"
                    :clear-button="true"
                    :clear-button-icon="'fa fa-times'"
                    id="input-data_nascimento"
                >
                </datepicker>
                
            </vs-col>           
        </vs-row>   

        <br/>
        <vs-row class="custom1" vs-w="12">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                <h5>País</h5>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="5" vs-xs="12">
                
                <v-select
                    class="selectWidth200"
                    label="pais"
                    v-model="rowSearch.cod_nacionalidade" 
                    name="nacionalidade"
                    autocomplete
                    id="input-cod_nacionalidade" 
                    :clearable="true" 
                    :options="countries"
                >
                    <span slot="no-options">{{$t('vSelectNoResults')}}</span>
                </v-select>
            </vs-col>     
        </vs-row> 

        <br/>
        <vs-row class="custom1" vs-w="12">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                <h5>Nº Identificação Fiscal</h5>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="5" vs-xs="12">
                <vs-input class="w-full" v-model="rowSearch.cod_fiscal" id="input-cod_fiscal"   
                    autocomplete="off" icon-pack="feather" icon="icon-check" icon-no-border 
                /> 
            </vs-col>     
        </vs-row>         

        <br/>
        <vs-row class="custom1" vs-w="12">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                <h5>Contacto</h5>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="5" vs-xs="12">
                <vs-input class="w-full" v-model="rowSearch.telefone" id="input-telefone"
                    autocomplete="off" icon-pack="feather" icon="icon-smartphone" icon-no-border
                /> 
            </vs-col> 
        </vs-row>           

        <br/>
        <vs-row class="custom1" vs-w="12">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                <h5>Email</h5>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="7" vs-sm="5" vs-xs="12"> 
                <vs-input class="w-full" v-model="rowSearch.email" id="input-email"
                   autocomplete="off" icon-pack="feather" icon="icon-mail" icon-no-border
                /> 
            </vs-col>     
        </vs-row>        

        <br/><br/>
        &nbsp;&nbsp;&nbsp;<span style="color:black;font-size: 12px;">*A pesquisa pelo nome só é possível em conjunto com outro critério de pesquisa.</span>                       

        <br/><br/>
        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
            <vs-button class="mr-3 mb-2" @click="searchClient()" icon-pack="feather" icon="icon-search" >Pesquisar</vs-button>              
            <vs-button color="warning" type="border" class="mb-2"
                @click="clearFields" 
                icon-pack="feather" icon="icon-delete"
            >
                Limpar
            </vs-button>                
        </vs-row>

    </vx-card>

    <vs-table        
        pagination
        max-items="10"
        search
        noDataText="Não foram encontrados registos"
        :data="clientSearchResult"
        @selected="handleClient"
        v-model="selectedContact"
    >
    <template slot="header">
        <h3>Lista de Clientes</h3>
    </template>

    <template slot="thead">
        <vs-th>
        </vs-th>
        <vs-th>
            Nome
        </vs-th>
        <vs-th>
            País
        </vs-th>
        <vs-th>
            Data de Nascimento
        </vs-th>
        <vs-th>
            Email
        </vs-th>
        <vs-th>
            Contacto
        </vs-th>
        
    </template>

    <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="data[indextr].client_info.name">
            </vs-td>

            <vs-td :data="data[indextr].client_info.nome">
                {{data[indextr].client_info.nome}} 
            </vs-td>

            <vs-td :data="data[indextr].client_info.nacionalidade_desc">
                {{data[indextr].client_info.nacionalidade_desc}} 
            </vs-td>

            <vs-td :data="data[indextr].client_info.data_nascimento">
                {{data[indextr].client_info.data_nascimento}}
            </vs-td>

            <vs-td :data="data[indextr].client_info.email">
                {{data[indextr].client_info.email}}
            </vs-td>

            <vs-td :data="data[indextr].client_info.telefone">
                {{data[indextr].client_info.telefone}}
            </vs-td>
        </vs-tr>
    </template>

    </vs-table>

    <vs-popup  :active.sync="showModal" @close="closepop" fullscreen :title="title">

        <vs-tabs alignment="fixed" position="top">

            <vs-tab label="Cliente" icon-pack="feather" icon="icon-user-check">
                <div>
                    <br/><br/>
                    <vx-card>
                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" >
                                <h5>Nome</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="5" vs-xs="12">
                                <vs-input class="w-full" name="nome" v-model="rowSelected.nome"
                                    autocomplete="off" icon-pack="feather" icon="icon-user" icon-no-border :disabled="client_if_staff == true"/> 
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="2" vs-xs="12">
                                <span class="text-danger text-sm" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
                            </vs-col>            
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" >
                                <h5>Género</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="5" vs-xs="12">
                                <vs-radio v-model="rowSelected.cod_sexo" vs-value="1" color="primary" 
                                    :disabled="client_if_staff == true"                          
                                >
                                    Masculino
                                </vs-radio>
                                &nbsp;&nbsp;&nbsp;
                                <vs-radio v-model="rowSelected.cod_sexo" vs-value="2" color="primary"
                                    :disabled="client_if_staff == true"                                            
                                >
                                    Feminimo
                                </vs-radio>                          
                            </vs-col>   
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="2" vs-xs="12">
                                <span class="text-danger text-sm" v-show="errors.has('cod_sexo')">{{ errors.first('cod_sexo') }}</span>
                                <span class="text-danger text-sm" v-show="scheduler_errors.genero">Campo Obrigatório</span>
                            </vs-col>          
                        </vs-row>  

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" >           
                                <h5>Data de Nascimento</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="5" vs-xs="12">
                                
                                <datepicker 
                                    :calendar-class="'calendar_date'"
                                    :format="datepickerFormat"
                                    :initial-view="'year'"
                                    v-model="rowSelected.data_nascimento"                                            
                                    name="data_nascimento"
                                    :disabled="client_if_staff == true"
                                    :clear-button="client_if_staff == true ? false : true"
                                    :clear-button-icon="'fa fa-times'"
                                >
                                </datepicker>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="2" vs-xs="12">                                        
                            </vs-col> 
                        </vs-row>
                        
                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" >                                           
                                <h5>País</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="5" vs-xs="12">
                                
                                <v-select
                                    class="selectWidth200"
                                    label="pais"
                                    v-model="rowSelected.cod_nacionalidade" 
                                    name="cod_nacionalidade"
                                    id="input-cod_nacionalidade" 
                                    :clearable="true" 
                                    :options="countries"
                                    :disabled="client_if_staff == true"
                                >
                                    <span slot="no-options">{{$t('vSelectNoResults')}}</span>
                                </v-select>

                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="2" vs-xs="12">
                                <span class="text-danger text-sm" v-show="errors.has('cod_nacionalidade')">{{ errors.first('cod_nacionalidade') }}</span>
                            </vs-col> 
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">                   
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" > 
                                <h5>Nº Identificação Fiscal</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="5" vs-xs="12">
                                <vs-input class="pform" name="cod_fiscal" autocomplete="off" v-model="rowSelected.cod_fiscal"
                                    icon-pack="feather" icon="icon-check" icon-no-border :disabled="client_if_staff == true"/> 
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="2" vs-xs="12">
                                <span class="text-danger text-sm" v-show="scheduler_errors.error_cod_fiscal">Nº de identificação fiscal incorrecto</span>
                                <span class="text-danger text-sm" v-show="scheduler_errors.error_cod_fiscal1">Nº de identificação fiscal já existe</span>
                            </vs-col> 
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">                   
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" > 
                                <h5>Contacto</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="5" vs-xs="12">
                                <vs-input class="pform" name="telefone" autocomplete="off" v-model="rowSelected.telefone"
                                    icon-pack="feather" icon="icon-smartphone" icon-no-border :disabled="client_if_staff == true"/>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="2" vs-xs="12">
                                <span class="text-danger text-sm" v-show="scheduler_errors.telefone">O “Contacto” é obrigatório caso o “Email” não se encontre 
                                    preenchido.</span>
                                <span class="text-danger text-sm" v-show="scheduler_errors.telefone1">O Contacto já existe</span>
                            </vs-col> 
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" >
                                <h5>Email</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="4" vs-xs="12">
                                <vs-input class="w-full" name="email" autocomplete="off" v-model="rowSelected.email"
                                    icon-pack="feather" icon="icon-mail" icon-no-border :disabled="client_if_staff == true"/> 
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="2" vs-xs="12">
                                <span class="text-danger text-sm" v-show="scheduler_errors.email">O “Email” é obrigatório caso o “Contacto” não se encontre 
                                    preenchido.</span>
                                <span class="text-danger text-sm" v-show="scheduler_errors.email1">O Email já existe</span>
                            </vs-col> 
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" >
                                <h5>Morada</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="4" vs-xs="12">
                                <vs-input class="w-full" v-model="rowSelected.morada" name="morada"
                                    autocomplete="off" icon-pack="feather" icon="icon-home" icon-no-border :disabled="client_if_staff == true"/> 
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="2" vs-xs="12">
                            </vs-col>  
                        </vs-row>                           

                        <br/><br/>
                        <vs-row vs-type="flex" vs-justify="center">                            
                            <vs-button type="border" color="warning" @click="modifyClient()" icon-pack="feather" icon="icon-edit" :disabled="client_if_staff == true"> Gravar</vs-button>
                        </vs-row>
                    </vx-card>  
                </div>  
            </vs-tab>

            <vs-tab label="Histórico" icon-pack="feather" icon="icon-save">
                <div>
                    <vs-table
                        pagination
                        max-items="10"
                        search
                        noDataText="Não foram encontrados registos"
                        :data="clientHistory"
                        :stripe="true"
                    >
                    <template slot="header">
                    </template>
        
                    <template slot="thead">
                        <vs-th>
                        </vs-th>
                        <vs-th>
                            Hotel
                        </vs-th>
                        <vs-th>
                            SPA
                        </vs-th>
                        <vs-th>
                            Terapeuta
                        </vs-th>
                        <vs-th>
                            Evento
                        </vs-th>
                        <vs-th>
                            Data
                        </vs-th>
                        <vs-th>
                            Observações
                        </vs-th>
                        <vs-th>
                            Cancelamento
                        </vs-th>
                        <vs-th>
                            Questionário
                        </vs-th>
                        <vs-th>
                            Cartão de Consulta
                        </vs-th>
                        
                    </template>
        
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                            <vs-td>                                
                            </vs-td>

                            <vs-td>
                                {{tr.hotel}} 
                            </vs-td>

                            <vs-td>
                                {{tr.spa}}
                            </vs-td>

                            <vs-td>
                                {{tr.therapist}}
                            </vs-td>

                            <vs-td>
                                {{tr.event}}
                            </vs-td>

                            <vs-td>
                                {{tr.date}}
                            </vs-td>

                            <vs-td v-if="data[indextr].comments != null">
                                {{tr.comments}}
                            </vs-td>
                            <vs-td v-else>
                                ---
                            </vs-td>

                            <vs-td v-if="data[indextr].status != ''">
                                {{tr.status}}
                            </vs-td>
                            <vs-td v-else>
                                ---
                            </vs-td>

                            <vs-td v-if="tr.status == ''">
                                <vs-button :color="'var(--vs-primary)'" class="mr-3 mb-2" @click="answerSurvey(tr)" 
                                    icon-pack="feather" icon="icon-check-circle" >Abrir</vs-button>
                            </vs-td>
                            <vs-td v-else>
                                ---
                            </vs-td>

                            <vs-td v-if="tr.status == ''">
                                <vs-button :color="'var(--vs-primary)'" class="mr-3 mb-2" @click="goToConsultationCard(tr)" 
                                    icon-pack="feather" icon="icon-align-center" >Abrir</vs-button>
                            </vs-td>
                            <vs-td v-else>
                                ---
                            </vs-td>

                        </vs-tr>
                    </template>

                </vs-table>
                
                </div>
            </vs-tab>

            <vs-tab label="Fidelização" icon-pack="feather" icon="icon-save">
                <div>
                    <vs-table
                        pagination
                        max-items="10"
                        search
                        noDataText="Não foram encontrados registos"
                        :data="clientLoyalty"
                        :stripe="true"
                    >
                    <template slot="header">
                    </template>
        
                    <template slot="thead">
                        <vs-th>
                        </vs-th>
                        <vs-th>
                            Cartão
                        </vs-th>
                        <vs-th>
                            Tipo
                        </vs-th>
                        <vs-th>
                            Nº Cartão
                        </vs-th>
                        <vs-th>
                            Data Atribuição
                        </vs-th>
                        <vs-th>
                            Estado
                        </vs-th>
                        
                    </template>
        
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                            <vs-td>                                
                            </vs-td>

                            <vs-td>
                                {{tr.cartao}} 
                            </vs-td>

                            <vs-td>
                                {{tr.tipo_cartao}}
                            </vs-td>

                            <vs-td>
                                {{tr.n_cartao}}
                            </vs-td>

                            <vs-td>
                                {{tr.data_atribuicao}}
                            </vs-td>

                            <vs-td>
                                {{tr.estado ? 'Ativo': 'Desativo'}}
                            </vs-td>

                        </vs-tr>
                    </template>

                </vs-table>
                
                </div>
            </vs-tab>

        </vs-tabs>
        
    </vs-popup>
  </div> 
</template>

<script>
import themeConfig from '@/../themeConfig.js';
import {DayPilot, DayPilotScheduler} from 'daypilot-pro-vue';

import Datepicker from 'vuejs-datepicker';                          
import vSelect from 'vue-select';                                   
import flatPickr from 'vue-flatpickr-component';                    
import 'flatpickr/dist/flatpickr.css';

import moment from 'moment';

import axios from 'axios'; 

import { Validator } from 'vee-validate';

const dict = {
  custom: {
    nome: {
      required: 'Campo Obrigatório ',
    },
    cod_nacionalidade: {
      required: 'Campo Obrigatório ',
    },
    cod_sexo: {
      required: 'Campo Obrigatório ',  
    },
  }
};

Validator.localize('pt', dict);

export default {
  name: 'client',
  props: [
  ], 
  
  components: {
    DayPilotScheduler,    
    Datepicker,               
    'v-select': vSelect,     
    flatPickr,                
  },

  data: function() {
    return {
        clientHistory: [],
        clientLoyalty: [],                 
        clientSearchResult: [],             
        showModal: false,  
        title: '',

        rowSelected : {},                  
        rowSearch : 
        {
            nome : '',
            data_nascimento :'',
            cod_nacionalidade : '',
            telefone : '',
            email : '',
            morada : '',
            cod_fiscal:'',
            cod_sexo: '',
        },         
        
        client_if_staff : false,

        scheduler_errors : 
        {
            genero : false,
            telefone : false,
            telefone1 : false,
            email: false,
            email1: false,
            error_cod_fiscal : false,
            error_cod_fiscal1 : false,            
        },
        countries: [],                     
        selectedContact: {},
    }
  },

  methods: {
    datepickerFormat(date){       
      return moment(date).format('YYYY-MM-DD');    
    },

    getCountries(){
        let that = this;

        let temptoken= window.localStorage.getItem('usertoken');
      
        axios({
            method: 'get',
            url: themeConfig.apiurl + '/profile/countries/bySpaClient',
            params: {
                token: temptoken,
            },
        })
        .then(function (res) 
        { 
            if(res.status == 200)
            { 
                that.countries=res.data;        
            }                                      
        })
        .catch( function (err) {
            console.log(err);
        })
    }, 
      
    closepop(){        
        if(this.$validator.errors.items.length > 0)
        {                   
            while(this.$validator.errors.items.length > 0)
            {
                this.$validator.errors.items.pop();
                
            }
        }

        this.scheduler_errors.error_cod_fiscal = false;
        this.scheduler_errors.error_cod_fiscal1 = false;
        this.scheduler_errors.genero = false;
        this.scheduler_errors.telefone = false;
        this.scheduler_errors.email = false;
        this.scheduler_errors.telefone1 = false;
        this.scheduler_errors.email1 = false;
    },  

    handleClient(tr){
        this.showModal = true;

        this.scheduler_errors.error_cod_fiscal = false;
        this.scheduler_errors.error_cod_fiscal1 = false;
        this.scheduler_errors.telefone1 = false;
        this.scheduler_errors.email1 = false;

        this.title="Editar Cliente";

        this.rowSelected = JSON.parse(JSON.stringify(tr.client_info)); 
        this.rowSelected.cod_nacionalidade = {
            cod_pais: tr.client_info.nacionalidade,
            pais: tr.client_info.nacionalidade_desc
        };

        if(this.rowSelected.is_staff == 1)
        {
            this.client_if_staff = true;
        }else
        {
            this.client_if_staff = false;
        }

        this.displayHistory(this.rowSelected);
        this.clientLoyalty = JSON.parse(JSON.stringify(tr.client_loyalty));
    },

    searchClient(){
        let that = this;

        if(this.rowSearch.data_nascimento === null)
        {
            this.rowSearch.data_nascimento = '';
        }

        if(this.rowSearch.nome.length == 0 && this.rowSearch.data_nascimento.length == 0 && this.rowSearch.cod_nacionalidade.length == 0 
            && this.rowSearch.telefone.length == 0 && this.rowSearch.email.length == 0 && this.rowSearch.morada.length == 0 
                && this.rowSearch.cod_fiscal.length == 0)
        {
            this.$vs.notify({title:'',text:'Por favor preencha os campos para a pesquisa',color:'Red',
                position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
        }else if(this.rowSearch.nome.length !== 0 && this.rowSearch.data_nascimento.length == 0 && this.rowSearch.cod_nacionalidade.length == 0 
            && this.rowSearch.telefone.length == 0 && this.rowSearch.email.length == 0 && this.rowSearch.morada.length == 0 
                && this.rowSearch.cod_fiscal.length == 0)
        {
            this.$vs.notify({title:'',text:'Por favor indique mais 1 campo para a pesquisa',color:'Red',
                position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
        }
        else
        {   
            let temptoken= window.localStorage.getItem('usertoken');

            this.$vs.loading();
        
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/profile/search/person/onSpas',
                params: {
                    token: temptoken,      
                    client: this.rowSearch,
                },
            })
            .then(function (res) 
            { 
                if(res.status == 200)
                { 
                    that.clientSearchResult=res.data; 
                                    
                    that.$store.dispatch('storeListSpaSearchedUsers',res.data);
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            })
            .then(function(){
                that.$vs.loading.close(); 
            }); 
        }
    }, 

    searchClient2(nome,data_nascimento,cod_nacionalidade,telefone,email){
        let that = this;

        this.rowSearch.nome = nome;
        this.rowSearch.data_nascimento = data_nascimento;
        this.rowSearch.cod_nacionalidade = cod_nacionalidade;
        this.rowSearch.telefone = telefone;
        this.rowSearch.email = email;

        if(this.rowSearch.data_nascimento === null)
        {
            this.rowSearch.data_nascimento = '';
        }

        if(this.rowSearch.nome.length == 0 && this.rowSearch.data_nascimento.length == 0 && this.rowSearch.cod_nacionalidade.length == 0 
            && this.rowSearch.telefone.length == 0 && this.rowSearch.email.length == 0 && this.rowSearch.cod_fiscal.length == 0)
        {
            this.$vs.notify({title:'',text:'Por favor preencha os campos para a pesquisa',color:'Red',
                position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
        }else if(this.rowSearch.nome.length !== 0 && this.rowSearch.data_nascimento.length == 0 && this.rowSearch.cod_nacionalidade.length == 0 
            && this.rowSearch.telefone.length == 0 && this.rowSearch.email.length == 0 && this.rowSearch.cod_fiscal.length == 0)
        {
            this.$vs.notify({title:'',text:'Por favor indique mais 1 campo para a pesquisa',color:'Red',
                position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
        }
        else
        {   
            let temptoken= window.localStorage.getItem('usertoken');

            this.$vs.loading();
        
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/profile/search/person/onSpas',
                params: {
                    token: temptoken,   
                    client: this.rowSearch,
                },
            })
            .then(function (res) 
            { 
                if(res.status == 200)
                { 
                    that.clientSearchResult=res.data; 
                                    
                    that.$store.dispatch('storeListSpaSearchedUsers',res.data);
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            })
            .then(function(){
                that.$vs.loading.close(); 
            });
        }
    },

    displayHistory(client){
        let that = this; 

        let temptoken= window.localStorage.getItem('usertoken');

        axios({
            method: 'get',
            url: themeConfig.apiurl + '/profile/show/person/onHistory',
            params: {
                token: temptoken, 
                client: client,
            },
        })
        .then(function (res) 
        { 
            if(res.status == 200)
            { 
                that.clientHistory=res.data; 
            }                                      
        })
        .catch( function (err) {
            console.log(err);
        });
    },

    answerSurvey(event_data) {
        let that = this;
    
        axios({
            method: 'get',
            url: themeConfig.apiurl + '/spa/validate/survey/' + event_data.event_schedule_id+'?token='+window.localStorage.getItem('usertoken'),
            params: {
                person : event_data.cod_pessoa,
            }
        }).then(function (response){
            if(response.status == 200){
                let routeData = '';
                if(response.data.survey == null){
                    routeData = that.$router.resolve({
                        name: 'survey2', params: {
                            data: event_data.event_schedule_id,
                        }});
                }else{
                    routeData = that.$router.resolve({
                        name: 'survey3', params: {
                            schedule_id: event_data.event_schedule_id,
                            survey_id: response.data.survey.spa_survey_id
                        }});
                }
                window.open(routeData.href, '_blank');
            }        
        }).catch(function (error){
            console.log(error.response);
        });
    }, 

    modifyClient(){
        this.$validator.validateAll().then(result => 
        {
            if (result)
            {                 
                let that = this;

                let res = this.validateBeforeModify();

                if(res == true)
                {               
                    let temptoken= window.localStorage.getItem('usertoken');

                    this.$vs.loading();
                
                    axios({
                        method: 'put',
                        url: themeConfig.apiurl + '/profile/modify/person/onSpas/' + this.rowSelected.cod_pessoa,
                        data: {
                            token: temptoken, 
                            client: this.rowSelected,
                        },
                    }).then(function (res) { 
                        if(res.status == 200){ 
                            if(res.data == "ERROR1"){
                                that.scheduler_errors.error_cod_fiscal = true;
                            }else if(res.data == "ERROR_VALIDATE_FISCAL"){
                                that.scheduler_errors.error_cod_fiscal1 = true;

                            }else if(res.data == "ERROR_VALIDATE_TELEFONE"){
                                that.scheduler_errors.telefone1 = true;
                            }else if(res.data == "ERROR_VALIDATE_EMAIL"){
                                that.scheduler_errors.email1 = true;
                            }else{
                                that.$store.dispatch('editListSpaSearchedUsers',res.data);

                                that.scheduler_errors.error_cod_fiscal = false;
                                that.scheduler_errors.error_cod_fiscal1 = false;
                                that.scheduler_errors.telefone1 = false;
                                that.scheduler_errors.email1 = false;
                            
                                that.$vs.notify({title:'',text:'Dados atualizados com sucesso.',color:'#63C0BB',position:'top-center'});
                            }
                        }
                    })
                    .catch( function (err) {
                        console.log(err);
                    }).then(function() {
                        that.$vs.loading.close();
                    }); 
                }
            }
        }); 
    },

    validateBeforeModify() {
        let errors_custom={};

        if(this.rowSelected.cod_sexo == 0)
        {
            this.scheduler_errors.genero = true;
            errors_custom['genero']= "error";
        }else
        {
            this.scheduler_errors.genero = false;
        }

        if(this.rowSelected.telefone.length == 0 && this.rowSelected.email.length == 0)
        {
            this.scheduler_errors.telefone = true;
            this.scheduler_errors.email = true;
            errors_custom['telefone']= "error";
        }else{
            this.scheduler_errors.telefone = false;
            this.scheduler_errors.email = false;
        }

        if(errors_custom.hasOwnProperty('genero') || errors_custom.hasOwnProperty('telefone') || errors_custom.hasOwnProperty('email')){
            return false;
        }
        return true;
    },

    clearFields(){
        Object.keys(this.rowSearch).forEach(k =>  this.rowSearch[k] = '');
        
        this.selectedContact = {};

        this.clientSearchResult= []

        this.rowSelected.cod_sexo = '';
    },
    goToConsultationCard(row){
        let routeData = '';
        if(row.consultation_card_id_code == null){
            routeData = this.$router.resolve({
                name: 'consultationCard', params: {
                    event_schedule_id: row.event_schedule_id_code,
                    cod_pessoa: row.cod_pessoa_code
                }});
        }else{
            routeData = this.$router.resolve({
                name: 'consultationCard', params: {
                    event_schedule_id: row.event_schedule_id_code,
                    cod_pessoa: row.cod_pessoa_code,
                    consultation_card_id: row.consultation_card_id_code
                }});
        }
        window.open(routeData.href, '_blank');
    },
    
  },
  created() {
    this.getCountries();
  }, 

  mounted(){
    let x = document.getElementById('input-cod_nacionalidade').getElementsByTagName('input')[0];

    let att =  document.createAttribute("autocomplete");
    att.value = "off";

    x.setAttributeNode(att);
  },

  computed: {      
  }, 

  watch: {}, 

} 

</script>

<style>

.calendar_date{  
  z-index: 999999 !important ;
}

.pform{
    width: 200px;
}

</style>

<style>

@media only screen and (max-width: 600px) {

h3 {
    font-size: 12px;
}
h4 {
    font-size: 12px;
}

h5 {
    font-size: 12px;
}
  
span {
    font-size: 10px;
}

.vs-popup--title h3{
    font-size: 0.8rem;
}

.vs-input--input.normal{
    font-size: .85rem;
}

.vs-input--input{
    width: 80%;
}

.vs-select--options span{
    font-size: .85rem;
}

.con-select .vs-select--input{
    font-size: .85rem;
}

.vdp-datepicker input{
    font-size: .85rem;
}

.vdp-datepicker__calendar{
        width: 200px !important;
}

.vdp-datepicker__calendar .month, .vdp-datepicker__calendar .year{
    width: 50%;
}

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: 5px 5px;
}

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large).vs-button-border {
    padding: 5px 5px;
}

.vs-col{
    padding: 0 5px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th{
    padding-top: 0; 
    padding-bottom: 0;
    font-size: .85rem;
}

} 
</style>

<style >
@media only screen and (max-width: 1280px) {

.custom1{
    width: 130% !important;
}

}
</style>
